import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HealthCheckService } from '@softline/application';

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  title = 'softapps';
  private healthCheckService = inject(HealthCheckService);

  ngOnInit(): void {
    this.healthCheckService.confirmHealth();
  }
}
